import React, { useState } from 'react';
import { Container, Typography, Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip } from '@mui/material';
import FileUploader from './FileUploader';
import DemigrationPanel from './DemigrationPanel';

const CSVDemigrator = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [csvHeaders, setCsvHeaders] = useState([]);

  const handleCsvDataLoaded = (data, headers) => {
    setCsvData(data);
    setCsvHeaders(headers);
  };

  return (
    <Container maxWidth="xl">
      <Box py={4}>
        <Typography variant="h4" component="h1" gutterBottom>
          CSV Demigration Tool
        </Typography>
        
        <FileUploader 
          onFilesSelected={setSelectedFiles}
          selectedFiles={selectedFiles}
          onCsvDataLoaded={handleCsvDataLoaded}
        />
        
        {selectedFiles.map((file, index) => (
          <DemigrationPanel 
            key={index} 
            file={file}
          />
        ))}

        {csvData.length > 0 && (
          <Paper elevation={2} sx={{ mt: 3, p: 2 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Typography variant="h5">CSV Data</Typography>
              <Chip 
                label={`Total Records: ${csvData.length}`} 
                color="primary" 
                size="large"
              />
            </Box>
            
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    {csvHeaders.map((header, index) => (
                      <TableCell key={index} sx={{ fontWeight: 'bold' }}>
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {csvData.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <TableCell key={cellIndex}>
                          {cell}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        )}
      </Box>
    </Container>
  );
};

export default CSVDemigrator;
